import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import Paper from '@material-ui/core/Paper';

export const StyledDialog = styled(Dialog)`
    ${({ theme }) => `
    background: ${theme.palette.common.backdrop};
    backdrop-filter: blur(2px);
    `}
`;

export const StyledPaper = styled(Paper)`
    ${({ theme }) => `
    background-color: ${theme.palette.common.white};
    width: 630px;
    border-radius: 16px;
    `}
`;

export const StyledEditSessionPaper = styled(Paper)`
    ${({ theme }) => `
    background-color: ${theme.palette.common.white};
    border-radius: 16px;
    max-width: 900px;
    width: 100%;
    `}
`;

export const StyledDialogContent = styled.div`
    ${({ theme }) => `
        padding: 10px 20px 0;
        border: 1px solid ${theme.palette.common.white};
        background-color: ${theme.palette.common.white};
        box-shadow:
            0px -2px 4px rgba(174, 180, 210, 0.4), inset 0px -2px 4px rgba(174, 180, 210, 0.2);
        backdrop-filter: blur(4px);
        border-radius: 16px;
    `}
`;

export const StyledConfirmAccountPaper = styled(Paper)`
    ${() => `
        background: transparent;
        width: 400px;
        border-radius: 16px;
    `}
`;

export const StyledMindGymIconContainer = styled.div`
    ${({ theme }) => `
        width: 40px;
        height: 40px;
        background-color: ${theme.palette.common.primaryBlue};
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;

        & img {
            width: 25px;
        }
    `}
`;
